// src/components/Form/Header.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa6';
import { useTheme } from '../../contexts/ThemeContext';
import './Header.css';

const Header = ({ urlBack, titulo, tituloBotao, eventoBotao, routeGoBack, semBotao }) => {
  const navigate = useNavigate();
  const { corApp, corFonteApp } = useTheme();

  const goBack = () => {
    if (urlBack) navigate(urlBack);
    else navigate(routeGoBack ? routeGoBack : -1);
  };

  const isOpen = tituloBotao === 'ABERTO';
  const themeStyle = {
    '--app-header-background': corApp,
    '--app-header-foreground': corFonteApp
  };

  return titulo ? (
    <header className="app-header" style={themeStyle}>
      <div className="app-header__inner">
        {!semBotao && (
          <button
            type="button"
            onClick={goBack}
            className="app-header__back-button"
            aria-label="Voltar"
          >
            <FaArrowLeft aria-hidden="true" />
          </button>
        )}
        <h1 className="app-header__title" title={titulo}>{titulo}</h1>
      </div>
    </header>
  ) : (
    <header className="app-header app-header--status" style={themeStyle}>
      <div className="app-header__inner">
        <div
          className={`app-header__status ${isOpen ? 'is-open' : 'is-closed'}`}
          role="status"
        >
          <span className="app-header__status-dot" aria-hidden="true" />
          {isOpen ? 'Aberto' : 'Fechado'}
        </div>
      </div>
    </header>
  );
};

export default Header;
